import { Link } from "react-router-dom";
import * as Animate from "react-reveal";
import BackgroundImg from "../../../assets/images/png/global-onboarding-v2.png";
import SelectedAvatar from "../../../assets/images/png/bankole-adesina-v1.png";
import { ArrowUpRight } from "../../../components/svgs";

const timeline = [
  { number: "01", title: "Contract generated", status: "Complete" },
  { number: "02", title: "Compliance review", status: "Complete" },
  { number: "03", title: "Onboarding", status: "Complete" },
  { number: "04", title: "Monthly payroll", status: "Scheduled" },
];

const HireTalentPhotoStorySection = () => {
  return (
    <section className="bg-white py-16 md:py-20 lg:py-24 px-4">
      <div className="container mx-auto grid grid-cols-1 lg:grid-cols-hire-after-hire items-center gap-10 lg:gap-16">
        <Animate.Fade bottom>
          <div>
            <p className="text-[#8b5a00] font-poppins text-sm font-extrabold tracking-widest uppercase mb-6">
              Hiring is only the beginning
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl leading-tight font-poppins font-black tracking-[-0.03em] mb-6">
              <span className="text-default">Once you select the person, </span>
              <span className="text-primary">Utiva runs the relationship.</span>
            </h2>
            <span className="text-gray text-base md:text-lg font-poppins leading-relaxed block">
              Contracts. Compliance. Payroll. Workforce Operations. One system.
            </span>
            <Link
              to="/pay"
              className="bg-primary text-secondary font-poppins font-extrabold rounded-xl inline-flex items-center gap-4 mt-8 px-5 py-4 custom-btn"
            >
              Explore Manage & Pay
              <ArrowUpRight className="w-3.5 h-3.5" />
            </Link>
          </div>
        </Animate.Fade>

        <Animate.Fade bottom>
          <div className="relative bg-[#0c0f49] rounded-3xl overflow-hidden min-h-[520px] md:min-h-[680px]">
            <img
              src={BackgroundImg}
              alt="A newly hired professional joining a global team"
              className="w-full h-full object-cover absolute inset-0"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#030447d1]"></div>

            <div className="relative z-[2] bg-[#eef2f9] backdrop-blur-md border border-white/60 rounded-3xl mx-5 mb-5 md:absolute md:bottom-5 md:left-5 md:right-5 md:mx-0 md:mb-0 p-4 md:p-5">
              <div className="bg-primary text-white rounded-2xl grid grid-cols-hire-employee-card items-center gap-4 p-4">
                <span className="text-secondary font-poppins text-xs font-extrabold tracking-widest">
                  EMPLOYEE SELECTED
                </span>
                <img
                  src={SelectedAvatar}
                  alt="Selected Utiva talent"
                  className="w-16 h-16 rounded-full object-cover border-2 border-white"
                />
                <div className="grid gap-0.5">
                  <strong className="text-lg">David K.</strong>
                  <small className="text-indigo-200 text-sm">
                    Product Manager · Remote
                  </small>
                </div>
                <b className="text-[#0b7140] bg-[#e4f7eb] rounded-full px-2.5 py-1.5 text-xs font-poppins">
                  READY ✓
                </b>
              </div>

              <ol className="grid gap-2 mt-3 p-0 list-none">
                {timeline.map((step) => (
                  <li
                    key={step.number}
                    className="border border-hire-line bg-white rounded-xl grid grid-cols-hire-timeline-row items-center gap-3 min-h-[64px] px-3.5 py-2.5"
                  >
                    <span className="text-[#8c94a7] font-poppins text-xs font-extrabold">
                      {step.number}
                    </span>
                    <p className="text-default font-poppins font-bold text-sm m-0">
                      {step.title}
                    </p>
                    <b className="text-[#0b7140] font-poppins text-xs">
                      {step.status} ✓
                    </b>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default HireTalentPhotoStorySection;
